import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { untrack } from "svelte";
import { bindEngine } from "../state/engine-bridge.svelte";
import { createEngine } from "../state/engine-factory";
import { art, debugMode } from "../state/params.svelte";

var root = $.from_html(`<div class="lost svelte-1qxkcgb8pbqhj"><p class="svelte-1qxkcgb8pbqhj">eigenvisuals could not start its renderer on this device.</p> <p class="detail svelte-1qxkcgb8pbqhj"> </p></div>`);
var root_1 = $.from_html(`<div class="lost svelte-1qxkcgb8pbqhj"><p class="svelte-1qxkcgb8pbqhj">The graphics context was lost.</p> <button class="svelte-1qxkcgb8pbqhj">Reload</button></div>`);
var root_2 = $.from_html(`<div class="host svelte-1qxkcgb8pbqhj"><canvas aria-hidden="true" class="svelte-1qxkcgb8pbqhj"></canvas> <!></div>`);

export default function CanvasHost($$anchor, $$props) {
	$.push($$props, true);

	let wrapper = $.state(void 0);
	let canvas = $.state(void 0);
	let contextLost = $.state(false);
	let initError = $.state(null);

	// Engine lifecycle. The effect body is fully untracked so it runs exactly
	// once (after mount); bindEngine's own child $effects do the reactive work.
	$.user_effect(() => untrack(() => {
		if (!$.get(wrapper) || !$.get(canvas)) return;

		const host = $.get(wrapper);

		// The App-level probe catches missing WebGL2, but the constructor can
		// still throw (second-context refusal, shader compile on odd drivers).
		let engine;

		try {
			engine = createEngine($.get(canvas), {
				seed: art.seed,
				params: $.snapshot(art.params),
				ignoreHidden: debugMode
			});
		} catch(e) {
			$.set(initError, e instanceof Error ? e.message : String(e), true);

			return;
		}

		const unbind = bindEngine(engine);

		// Sizing: device-pixel-content-box where supported, contentRect × dpr
		// fallback (Safari); applied debounced one rAF.
		let raf = 0;

		let pending = null;

		const applySize = () => {
			raf = 0;

			if (!pending) return;

			engine.resize(pending.w, pending.h, pending.dpr);
			pending = null;
		};

		const ro = new ResizeObserver((entries) => {
			const entry = entries[entries.length - 1];

			if (!entry) return;

			const w = entry.contentRect.width;
			const h = entry.contentRect.height;
			let dpr = window.devicePixelRatio || 1;
			const dp = entry.devicePixelContentBoxSize?.[0];

			if (dp && w > 0) dpr = dp.inlineSize / w;

			pending = { w, h, dpr: Math.min(dpr, 2) };

			if (!raf) raf = requestAnimationFrame(applySize);
		});

		try {
			ro.observe(host, { box: "device-pixel-content-box" });
		} catch {
			ro.observe(host); // Safari: no device-pixel-content-box
		}

		// Auto-pause when the tab is hidden — never writes art.paused.
		// debug=1 opts out so the sim keeps running while unfocused.
		const onVisibility = () => {
			if (debugMode) return;
			if (document.hidden) engine.pause(); else if (!art.paused) engine.resume();
		};

		document.addEventListener("visibilitychange", onVisibility);

		const offLost = engine.on("contextlost", () => {
			$.set(contextLost, true);
		});

		const offRestored = engine.on("contextrestored", () => {
			$.set(contextLost, false);
		});

		// The ONE sanctioned engine→store backchannel (contextlost above only
		// touches local state): settled drives the Replay affordance in
		// ActionBar and the Space shortcut.
		art.settled = engine.settled;

		const offSettled = engine.on("settled", () => {
			art.settled = true;
		});

		const offDrawing = engine.on("drawing", () => {
			art.settled = false;
		});

		return () => {
			ro.disconnect();

			if (raf) cancelAnimationFrame(raf);

			document.removeEventListener("visibilitychange", onVisibility);
			offLost();
			offRestored();
			offSettled();
			offDrawing();
			unbind();
			engine.destroy();
		};
	}));

	var div = root_2();
	var canvas_1 = $.child(div);

	$.bind_this(canvas_1, ($$value) => $.set(canvas, $$value), () => $.get(canvas));

	var node = $.sibling(canvas_1, 2);

	{
		var consequent = ($$anchor) => {
			var div_1 = root();
			var p = $.sibling($.child(div_1), 2);
			var text = $.child(p, true);

			$.reset(p);
			$.reset(div_1);
			$.template_effect(() => $.set_text(text, $.get(initError)));
			$.append($$anchor, div_1);
		};

		var consequent_1 = ($$anchor) => {
			var div_2 = root_1();
			var button = $.sibling($.child(div_2), 2);

			$.reset(div_2);
			$.delegated('click', button, () => location.reload());
			$.append($$anchor, div_2);
		};

		$.if(node, ($$render) => {
			if ($.get(initError)) $$render(consequent); else if ($.get(contextLost)) $$render(consequent_1, 1);
		});
	}

	$.reset(div);
	$.bind_this(div, ($$value) => $.set(wrapper, $$value), () => $.get(wrapper));
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:CanvasHost.svelte-krmpovyfctdi-style.css";